// Components==============
import BackButton from 'components/Layout/BackButton/BackButton';
import Background from 'components/Layout/Background/Background';
import Menu from 'components/Layout/Menu/Menu';
import NavigationBox from 'components/Layout/NavigationBox/NavigationBox';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Audio from './Audio/Audio';
import AutoCorrection from './AutoCorrection/AutoCorrection';
import Info from './Info/Info';
import Keyboard from './Keyboard/Keyboard';
import Recording from './Recording/Recording';
import './Test.module.scss';
import Tiles from './TIles/Tiles';
// =========================

export type AutoCorrectionStatus = 'initial' | 'correct' | 'wrong';

const navigationContent = (autoCorrectionStatus: AutoCorrectionStatus) => [
    {
        id: 'audio',
        title: 'Geluidstest',
        description: 'Druk op de playknop om te testen of het geluid werkt.',
    },
    {
        id: 'recording',
        title: 'Geluidsopname test',
        description:
            'Klik op de rode opnameknop en spreek iets in. Om de opname te stoppen klik je op de rode stopknop. Om te controleren of de opname is gelukt, klik je op de blauwe playknop die verschijnt.',
    },
    {
        id: 'key',
        title: 'Klankenbord toetsenbord test',
        description:
            'Gebruik de toetsen op dit klankenbord toetsenbord. Als de letters in het tekstveld verschijnen, werkt het toetsenbord goed.',
    },
    {
        id: 'tiles',
        title: 'Blokjes slepen test',
        description:
            'Sleep een blokje naar een van de vakjes. Zodra het blokje in het vakje valt, werkt het slepen van de blokjes goed.',
    },
    {
        id: 'auto-correction',
        title: 'Autocorrectie test',
        description:
            autoCorrectionStatus === 'correct'
                ? 'Je hebt geen autocorrectie aan staan!'
                : autoCorrectionStatus === 'wrong'
                ? 'Oeps.. je hebt autocorrectie aan staan'
                : 'Schrijf in het tekstveld hieronder: de feits van Jan. Als de tekst niet aangepast wordt, dan staat de autocorrectie uit.',
    },
    {
        id: 'info',
        title: 'Device gegevens',
        description: <Info />,
    },
];

const audioFiles = [
    '1.-Geluidstest',
    '2.-Geluidsopname-test',
    '3.-Klankenbord-toetsenbord-test',
    '4.-Blokjes-slepen-test',
    '5.-Autocorrectie-test',
];

export default function Test() {
    const user = useSelector(
        (state: ReduxStore) => !!state.authentication?.user
    );

    const [
        autoCorrectionStatus,
        setAutoCorrectionStatus,
    ] = useState<AutoCorrectionStatus>('initial');

    const [currentNav, setCurrentNav] = useState(0);

    const content = navigationContent(autoCorrectionStatus);

    const currentNavContent = content[currentNav];

    const { id, title, description } = currentNavContent;

    return (
        <Background background="city">
            <NavigationBox
                displayMode={id === 'info' ? 'centered' : 'centered-y'}
                top={id === 'info' ? undefined : '2em'}
                previous={
                    currentNav === 0
                        ? undefined
                        : () => setCurrentNav((prev) => prev - 1)
                }
                next={
                    currentNav === content.length - 1
                        ? undefined
                        : () => setCurrentNav((prev) => prev + 1)
                }
                title={title}
                text={description}
                audio={`/audio/test-page/${audioFiles[currentNav]}.mp3`}
            />
            <div styleName="wrapper">
                {id === 'audio' ? (
                    <Audio />
                ) : id === 'recording' ? (
                    <Recording />
                ) : id === 'key' ? (
                    <Keyboard />
                ) : id === 'tiles' ? (
                    <Tiles />
                ) : id === 'auto-correction' ? (
                    <AutoCorrection
                        autoCorrectionStatus={autoCorrectionStatus}
                        setAutoCorrectionStatus={setAutoCorrectionStatus}
                    />
                ) : (
                    <></>
                )}
            </div>
            <BackButton />
            {user && <Menu />}
        </Background>
    );
}
